(function () {
  if (window.__rbFitFinderCartInit) return;
  window.__rbFitFinderCartInit = true;

  const FF_PARENT_PROP = '_fit_finder_parent';
  const FF_BUNDLE_PROP = '_fit_finder_bundle';
  const FF_ADDON_PROP = '_fit_finder_addon';
  const FF_QTY_PER_MAIN_PROP = '_fit_finder_qty_per_main';
  const FF_BELLY_PROP = '_fit_finder_belly';
  const FF_THIGH_PROP = '_fit_finder_thigh';

  function createFitFinderBundleId() {
    return `ff_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 9)}`;
  }

  function readFitFinderCartItems() {
    try {
      const raw = sessionStorage.getItem('ve_fit_finder_cart_items');
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((item) => {
        const id = parseInt(item?.id, 10);
        return id && !Number.isNaN(id);
      });
    } catch {
      return [];
    }
  }

  function readExtensionSummary() {
    try {
      const raw = sessionStorage.getItem('ve_fit_finder_extension_summary');
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  function readFitFinderMeasurements() {
    try {
      const raw = sessionStorage.getItem('ve_fit_finder_measurements');
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  function isFitFinderConfigured() {
    return sessionStorage.getItem('ve_fit_finder_calculated') === '1';
  }

  function clearFitFinderSession() {
    try {
      sessionStorage.removeItem('ve_fit_finder_cart_items');
      sessionStorage.removeItem('ve_fit_finder_extension_summary');
      sessionStorage.removeItem('ve_fit_finder_measurements');
      sessionStorage.removeItem('ve_fit_finder_pricing');
      sessionStorage.removeItem('ve_fit_finder_needs_support');
      sessionStorage.removeItem('ve_fit_finder_calculated');
      sessionStorage.removeItem('ve_fit_finder_result_type');
      sessionStorage.removeItem('ve_fit_finder_main_variant_id');
    } catch {
      /* ignore */
    }
    document.dispatchEvent(
      new CustomEvent('fit-finder:calculated', {
        bubbles: true,
        detail: {
          cartItems: [],
          extensionSummary: { calculated: false, totalCents: 0, formatted: '' },
        },
      })
    );
    document.dispatchEvent(new CustomEvent('fit-finder:cleared', { bubbles: true }));
  }

  function getCheckedBuyWithItems() {
    return Array.from(document.querySelectorAll('[data-rb-buy-with-checkbox]:checked'))
      .map((cb) => ({
        id: parseInt(cb.value, 10),
        quantity: 1,
      }))
      .filter((item) => item.id && !Number.isNaN(item.id));
  }

  function getFitFinderEl() {
    return document.querySelector('rb-fit-finder');
  }

  function readExtensionPrices() {
    try {
      return JSON.parse(getFitFinderEl()?.querySelector('[data-extension-prices]')?.textContent || '{}');
    } catch {
      return {};
    }
  }

  function getAddonVariantIds() {
    const el = getFitFinderEl();
    const ids = new Set();
    if (!el) return ids;

    const extensionPrices = readExtensionPrices();
    ['a', 'b', 'c'].forEach((letter) => {
      const attrId = parseInt(el.getAttribute(`data-variant-${letter}`), 10);
      const jsonId = parseInt(extensionPrices?.[letter]?.variantId, 10);
      [attrId, jsonId].forEach((id) => {
        if (id && !Number.isNaN(id)) ids.add(id);
      });
    });

    readFitFinderCartItems().forEach((item) => {
      const id = parseInt(item.id, 10);
      if (id && !Number.isNaN(id)) ids.add(id);
    });

    return ids;
  }

  function readSavedMainVariantId() {
    try {
      const id = parseInt(sessionStorage.getItem('ve_fit_finder_main_variant_id'), 10);
      return id && !Number.isNaN(id) ? id : null;
    } catch {
      return null;
    }
  }

  function findAddToCartForm() {
    const fitFinderBlock = getFitFinderBlock();
    const productInfo = fitFinderBlock?.closest('product-info');
    const scope = productInfo || document;

    const atcBtn = scope.querySelector('[data-fit-finder-atc]');
    const atcForm = atcBtn?.closest('form[data-type="add-to-cart-form"]');
    if (atcForm) return atcForm;

    if (productInfo) {
      const form = productInfo.querySelector('form[data-type="add-to-cart-form"]');
      if (form) return form;
    }
    return document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function getMainVariantId(_form, mainVariantOverride) {
    const addonIds = getAddonVariantIds();
    const fitFinder = getFitFinderEl();
    const prices = readExtensionPrices();
    const sectionVariantId = parseInt(prices?.main?.variantId, 10);

    const candidates = [
      mainVariantOverride,
      parseInt(fitFinder?.getAttribute('data-main-variant-id'), 10),
      sectionVariantId,
    ];

    for (const raw of candidates) {
      const id = parseInt(raw, 10);
      if (id && !Number.isNaN(id) && !addonIds.has(id)) return id;
    }

    return null;
  }

  function getMainQuantity(form) {
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value, 10);
    return qty && !Number.isNaN(qty) ? qty : 1;
  }

  function getFormProperties(form) {
    const properties = {};
    form.querySelectorAll('input[name^="properties["], textarea[name^="properties["]').forEach((el) => {
      const match = el.name.match(/^properties\[(.+)\]$/);
      if (match && el.value) properties[match[1]] = el.value;
    });
    return properties;
  }

  function childProperties(bundleId, isFitFinderAddon, qtyPerMain) {
    const properties = { [FF_PARENT_PROP]: String(bundleId) };
    if (isFitFinderAddon) {
      properties[FF_ADDON_PROP] = 'true';
      const perMain = parseInt(qtyPerMain, 10);
      if (perMain && !Number.isNaN(perMain) && perMain > 0) {
        properties[FF_QTY_PER_MAIN_PROP] = String(perMain);
      }
    }
    return properties;
  }

  function fitFinderMainProperties(form, bundleId) {
    const properties = getFormProperties(form);
    properties[FF_BUNDLE_PROP] = bundleId;
    const measurements = readFitFinderMeasurements();
    if (measurements?.belly != null) properties[FF_BELLY_PROP] = `${measurements.belly} cm`;
    if (measurements?.thigh != null) properties[FF_THIGH_PROP] = `${measurements.thigh} cm`;
    return properties;
  }

  function buildFitFinderLines(form, cartItemsOverride, mainVariantOverride) {
    const mainId = getMainVariantId(form, mainVariantOverride);
    if (!mainId) return null;

    const fitFinderItems = Array.isArray(cartItemsOverride) ? cartItemsOverride : readFitFinderCartItems();
    const configured = isFitFinderConfigured() || cartItemsOverride != null;
    if (!configured) return null;

    const buyWithItems = getCheckedBuyWithItems();
    const bundleId = createFitFinderBundleId();
    const mainProperties = fitFinderMainProperties(form, bundleId);
    const mainLine = {
      id: mainId,
      quantity: getMainQuantity(form),
      properties: mainProperties,
    };

    const children = [];
    const seenChildIds = new Set();
    const mainQty = getMainQuantity(form);

    fitFinderItems.forEach((item) => {
      const childId = parseInt(item.id, 10);
      if (!childId || childId === mainId || seenChildIds.has(childId)) return;
      seenChildIds.add(childId);
      const qtyPerMain = item.quantity || 1;
      children.push({
        id: childId,
        quantity: qtyPerMain * mainQty,
        properties: childProperties(bundleId, true, qtyPerMain),
      });
    });

    buyWithItems.forEach((item) => {
      if (!item.id || item.id === mainId || seenChildIds.has(item.id)) return;
      seenChildIds.add(item.id);
      children.push({
        id: item.id,
        quantity: 1,
      });
    });

    return { bundleId, mainId, mainLine, children };
  }

  function patchCartRenderContents(cart) {
    if (!cart?.renderContents || cart.__rbFitFinderRenderPatch) return;
    cart.__rbFitFinderRenderPatch = true;
    const original = cart.renderContents.bind(cart);
    cart.renderContents = function (parsedState) {
      if (!parsedState.key && parsedState.items?.length) {
        parsedState.key = parsedState.items[parsedState.items.length - 1].key;
      }
      original(parsedState);
    };
  }

  function getSectionsPayload(cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') return {};
    const sectionIds = cart.getSectionsToRender().map((section) => section.id);
    if (!sectionIds.length) return {};
    return {
      sections: sectionIds.join(','),
      sections_url: window.location.pathname,
    };
  }

  function getCartAddUrl() {
    return window.routes?.cart_add_js_url || `${window.routes?.cart_add_url || '/cart/add'}.js`;
  }

  async function postCartAdd(items, cart) {
    const response = await fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items,
        ...getSectionsPayload(cart),
      }),
    });
    return response.json();
  }

  function showProductFormError(productFormEl, message) {
    if (!productFormEl || !message) return;
    const wrapper = productFormEl.querySelector('.product-form__error-message-wrapper');
    const messageEl = productFormEl.querySelector('.product-form__error-message');
    if (wrapper) wrapper.hidden = false;
    if (messageEl) messageEl.textContent = message;
  }

  function setLoading(productFormEl, loading) {
    const submitButton = productFormEl?.querySelector('[data-fit-finder-atc]') || productFormEl?.querySelector('[type="submit"]');
    const blockAtcButtons = document.querySelectorAll('[data-fit-finder-block-atc]');
    const spinner = productFormEl?.querySelector('.loading__spinner');
    const buttons = [submitButton, ...blockAtcButtons].filter(Boolean);

    if (loading) {
      buttons.forEach((btn) => {
        if (!btn.dataset.rbFitFinderWasDisabled) {
          btn.dataset.rbFitFinderWasDisabled = btn.disabled ? 'true' : 'false';
        }
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        btn.disabled = true;
      });
    } else {
      buttons.forEach((btn) => {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
        if (btn.dataset.rbFitFinderWasDisabled === 'true') {
          btn.disabled = true;
        } else {
          btn.disabled = false;
        }
        delete btn.dataset.rbFitFinderWasDisabled;
      });
    }

    if (spinner) spinner.classList.toggle('hidden', !loading);
  }

  function finishCartUi(cart, data, productFormEl) {
    if (!cart) {
      window.location = window.routes?.cart_url || '/cart';
      return true;
    }

    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'rb-fit-finder-cart',
        cartData: data,
      });
    }

    cart.classList.remove('is-empty');
    try {
      cart.renderContents(data);
    } catch (renderError) {
      console.error('rb-fit-finder-cart renderContents failed', renderError);
      window.location = window.routes?.cart_url || '/cart';
    }
    return true;
  }

  function buildCartAddItems(bundle) {
    return [bundle.mainLine, ...bundle.children];
  }

  async function addFitFinderToCart(form, productFormEl, cartItemsOverride, mainVariantOverride) {
    const bundle = buildFitFinderLines(form, cartItemsOverride, mainVariantOverride);
    if (!bundle) return false;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart) {
      patchCartRenderContents(cart);
      cart.setActiveElement(document.activeElement);
    }

    setLoading(productFormEl, true);

    try {
      let data = await postCartAdd(buildCartAddItems(bundle), cart);
      if (data.status) {
        showProductFormError(productFormEl, data.description || data.message);
        return false;
      }

      clearFitFinderSession();
      document.querySelector('rb-fit-finder')?.reset?.();
      return finishCartUi(cart, data, productFormEl);
    } catch (error) {
      console.error('rb-fit-finder-cart add failed', error);
      showProductFormError(productFormEl, window.cartStrings?.error || 'Cart update failed.');
      return false;
    } finally {
      setLoading(productFormEl, false);
      if (isFitFinderConfigured()) {
        updateAtcUi(true);
      }
    }
  }

  function getFitFinderBlock() {
    return document.querySelector('[data-fit-finder-block]');
  }

  function getProductForm() {
    const form = findAddToCartForm();
    return form?.closest('product-form');
  }

  function getAtcButton(productForm) {
    if (!productForm) return null;
    return productForm.querySelector('[data-fit-finder-atc]') || productForm.querySelector('[type="submit"]');
  }

  function getDefaultAtcLabel(productForm) {
    const btn = getAtcButton(productForm);
    if (!btn) return '';
    if (!btn.dataset.rbFitFinderDefaultLabel) {
      const labelEl = btn.querySelector('.product-form__submit-label');
      btn.dataset.rbFitFinderDefaultLabel = labelEl?.textContent?.trim() || btn.textContent?.trim() || '';
    }
    return btn.dataset.rbFitFinderDefaultLabel;
  }

  function updateAtcUi(configured) {
    const productForm = getProductForm();
    if (!productForm || !getFitFinderBlock()) return;

    const btn = getAtcButton(productForm);
    const labelEl = btn?.querySelector('.product-form__submit-label');

    productForm.classList.toggle('fit-finder--atc-ready', configured);

    if (btn && labelEl) {
      const defaultLabel = getDefaultAtcLabel(productForm);
      if (defaultLabel) labelEl.textContent = defaultLabel;
    }
  }

  async function handleFormSubmit(evt) {
    const form = evt.target;
    if (!form?.matches('form[data-type="add-to-cart-form"]')) return;
    if (!getFitFinderBlock()) return;
    if (!isFitFinderConfigured()) return;

    const bundle = buildFitFinderLines(form);
    if (!bundle) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    const productFormEl = form.closest('product-form');
    await addFitFinderToCart(form, productFormEl);
  }

  function onFitFinderConfigured(event) {
    const detail = event.detail || {};
    if (!detail.calculated) {
      updateAtcUi(false);
      return;
    }
    updateAtcUi(true);
    initFormHook();
  }

  function onFitFinderCleared() {
    updateAtcUi(false);
  }

  function bindVariantChangeClear(form) {
    if (!form || form.dataset.rbFitFinderVariantBound) return;
    form.dataset.rbFitFinderVariantBound = 'true';

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;

    let lastVariantId = variantInput.value;
    const onVariantChange = () => {
      if (variantInput.value === lastVariantId) return;
      lastVariantId = variantInput.value;
      if (isFitFinderConfigured()) {
        clearFitFinderSession();
        document.querySelector('rb-fit-finder')?.reset?.();
      }
    };

    variantInput.addEventListener('change', onVariantChange);
    document.addEventListener('variant:change', onVariantChange);
  }

  function initFormHook() {
    const form = findAddToCartForm();
    if (!form || form.dataset.rbFitFinderNestedBound) return;
    form.dataset.rbFitFinderNestedBound = 'true';
    form.addEventListener('submit', handleFormSubmit, true);
    bindVariantChangeClear(form);

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    patchCartRenderContents(cart);
  }

  function restoreFromSession() {
    updateAtcUi(isFitFinderConfigured());
  }

  async function onFitFinderAddToCart(event) {
    const form = findAddToCartForm();
    if (!form) return;
    const productFormEl = form.closest('product-form');
    const cartItems = event.detail?.cartItems;
    await addFitFinderToCart(form, productFormEl, cartItems, event.detail?.mainVariantId);
  }

  document.addEventListener('fit-finder:configured', onFitFinderConfigured);
  document.addEventListener('fit-finder:cleared', onFitFinderCleared);
  document.addEventListener('fit-finder:add-to-cart', onFitFinderAddToCart);
  document.addEventListener('fit-finder:state', (event) => {
    if (event.detail?.state === 'configured') {
      onFitFinderConfigured({ detail: { calculated: true } });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initFormHook();
      restoreFromSession();
    });
  } else {
    initFormHook();
    restoreFromSession();
  }
})();
